import React from 'react';
import { TechnologyTab } from '../components/technology/TechnologyTab';

interface TechnologyProps {
  onShowHelp?: () => void;
}

export const Technology: React.FC<TechnologyProps> = ({ onShowHelp }) => {
  return (
      <TechnologyTab onShowHelp={onShowHelp} />
  );
};
